module.exports = __webpack_public_path__ + "assets/places_white.7007ffc3.svg";